import dayjs, { Dayjs } from "dayjs";

export function isDayjsBeforeToday(value: Dayjs): boolean {
    const today = dayjs();

    return value.isBefore(today, "date");
}
